import { useRoot } from "@/stores/root";
const rootState = useRoot();

type FunctionParam = (...args: any[]) => Promise<any>

export const attempt = async (fn: FunctionParam, ...args: any[]) => {
    try {
        return await fn(...args)
    } catch (error) {
        rootState.error = true
    }
}